// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 全局样式重置 */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f5f5f5;
}

/* 在移动端和PAD端防止页面级别的滚动条 */
@media (max-width: 768px) {
  body {
    overflow: hidden;
  }
}

.App {
  min-height: 100vh;
}

.game-card-link {
  display: block;
  height: 100%;
  color: inherit;
  text-decoration: none;
}

.game-card-link:hover {
  color: inherit;
}

/* 在移动端和PAD端使用固定高度布局 */
@media (max-width: 768px) {
  .App {
    height: 100vh;
    overflow: hidden;
  }
}

/* 自定义滚动条 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Ant Design 组件样式覆盖 */
.ant-layout {
  background: #f5f5f5;
}

.ant-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
}

.ant-btn-primary {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  border: none;
  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
  transition: all 0.3s ease;
}

.ant-btn-primary:hover {
  background: linear-gradient(135deg, #40a9ff, #69c0ff);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
}

.ant-pagination-item-active {
  background: #1890ff;
  border-color: #1890ff;
}

.ant-pagination-item-active a {
  color: #fff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ant-card {
    border-radius: 8px;
    margin: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,WAAW;AACX;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,WAAW;AACX;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;AACV;EACE;IACE,kBAAkB;IAClB,WAAW;EACb;AACF","sourcesContent":["/* 全局样式重置 */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f5f5f5;\n}\n\n/* 在移动端和PAD端防止页面级别的滚动条 */\n@media (max-width: 768px) {\n  body {\n    overflow: hidden;\n  }\n}\n\n.App {\n  min-height: 100vh;\n}\n\n.game-card-link {\n  display: block;\n  height: 100%;\n  color: inherit;\n  text-decoration: none;\n}\n\n.game-card-link:hover {\n  color: inherit;\n}\n\n/* 在移动端和PAD端使用固定高度布局 */\n@media (max-width: 768px) {\n  .App {\n    height: 100vh;\n    overflow: hidden;\n  }\n}\n\n/* 自定义滚动条 */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Ant Design 组件样式覆盖 */\n.ant-layout {\n  background: #f5f5f5;\n}\n\n.ant-card {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: none;\n}\n\n.ant-btn-primary {\n  background: linear-gradient(135deg, #1890ff, #40a9ff);\n  border: none;\n  box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);\n  transition: all 0.3s ease;\n}\n\n.ant-btn-primary:hover {\n  background: linear-gradient(135deg, #40a9ff, #69c0ff);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);\n}\n\n.ant-pagination-item-active {\n  background: #1890ff;\n  border-color: #1890ff;\n}\n\n.ant-pagination-item-active a {\n  color: #fff;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .ant-card {\n    border-radius: 8px;\n    margin: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
